const availableHeaders = [
  'applicant_id',
  'street_address_1', // Map from original street_address_1 field to match DB column
  'street_address_2', // Map from original street_address_2 field to match DB column
  'street_address_3', // Map from original street_address_3 field to match DB column
  'city',
  'state',
  'zip',
  'country',
  'geoid',
  'hs_ceeb_code', // hs_ceeb_code
  'gender',
  'sat_math',
  'sat_ebrw',
  'act_composite',
  'old_sat_math',
  'old_sat_cr',
  'old_sat_writing',
  'act_english',
  'act_math',
  'act_science',
  'act_reading',
  'act_writing',
  'application_type',
  'admitted',
  'enrolled',
  'waitlist',
  'first_year_gpa',
  'sophomore_retention',
  'race',
  'entry_term',
  'first_generation',
  'hsgpa',
  'pell_eligible',
  'number_of_ap_exams',
  'ap_average',
  'number_of_ib_exams',
  'ib_average',
  'custom_1',
  'custom_2',
  'custom_3',
]
export { availableHeaders }
